export default __webpack_public_path__ + "static/media/CivilEng_Shapes-02.4012661b.png";